import React, { useState, useEffect } from 'react';
import { FileText, Download, Calendar, User, TrendingUp, BarChart3 } from 'lucide-react';
import axios from 'axios';

const PersonelKarnesi = () => {
  const [personnelList, setPersonnelList] = useState([]);
  const [selectedPersonnel, setSelectedPersonnel] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [selectedProductCompanies, setSelectedProductCompanies] = useState(null);

  // Bizim acente şirketleri
  const bizimAcenteShirketleri = [
    'Ak Sigorta', 'Ana Sigorta', 'Axa Sigorta', 'Anadolu Sigorta',
    'Allianz Sigorta', 'Türkiye Sigorta', 'Doğa Sigorta', 'Atlas Mutuel Sigorta',
    'Türkiye Katılım Sigorta', 'Emaa Sigorta', 'Sompo Sigorta', 'Neova Sigorta', 
    'Quick Sigorta', 'Ray Sigorta', 'Magdeburger Sigorta', 'Hdi Sigorta', 
    'Mapfre Sigorta', 'Hepiyi Sigorta'
  ];

  // Dış acente şirketleri
  const disAcenteShirketleri = [
    'Ankara Sigorta','GNC Yol Yardım',
    'Türk Nippon Sigorta','Koru Sigorta',
    'Referans Sigorta', 'Corpus Sigorta'
  ];

  // Personel listesini getir
  useEffect(() => {
    fetchPersonnelList();
  }, []);

const fetchPersonnelList = async () => {
  try {
    const response = await axios.get('https://centalyayanimda.com/get_personnel.php');
    if (response.data.success && response.data.data) {
      setPersonnelList(response.data.data); // .data.data
    } else {
      setPersonnelList([]);
    }
  } catch (error) {
    console.error('Personel listesi alınırken hata:', error);
    setPersonnelList([]);
  }
};

  // Rapor verilerini getir
  const fetchReportData = async () => {
    if (!selectedPersonnel || !selectedMonth || !selectedYear) {
      alert('Lütfen personel ve tarih seçimi yapın');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('https://centalyayanimda.com/get_personnel_report.php', {
        personnel_id: selectedPersonnel,
        month: selectedMonth,
        year: selectedYear
      });
      
      if (response.data.success) {
        setReportData(response.data.data);
      } else {
        alert('Rapor alınırken hata: ' + response.data.message);
      }
    } catch (error) {
      console.error('Rapor alınırken hata:', error);
      alert('Rapor alınırken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  // PDF oluştur
  const generatePDF = () => {
    if (!reportData) {
      alert('Önce rapor verilerini alın');
      return;
    }
    // PDF oluşturma fonksiyonu buraya gelecek
    console.log('PDF oluşturuluyor...');
  };

  // Ay listesi
  const months = [
    { value: '01', label: 'Ocak' },
    { value: '02', label: 'Şubat' },
    { value: '03', label: 'Mart' },
    { value: '04', label: 'Nisan' },
    { value: '05', label: 'Mayıs' },
    { value: '06', label: 'Haziran' },
    { value: '07', label: 'Temmuz' },
    { value: '08', label: 'Ağustos' },
    { value: '09', label: 'Eylül' },
    { value: '10', label: 'Ekim' },
    { value: '11', label: 'Kasım' },
    { value: '12', label: 'Aralık' }
  ];

  // Yıl listesi (son 5 yıl)
  const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(amount);
  };

  // Ürün detayını göster
  const showProductCompanies = (product) => {
    setSelectedProductCompanies(product);
    setShowCompanyModal(true);
  };

  // Modal'ı kapat
  const closeModal = () => {
    setShowCompanyModal(false);
    setSelectedProductCompanies(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 mb-6 shadow-lg">
          <div className="flex items-center space-x-3 mb-6">
            <FileText className="text-blue-600" size={32} />
            <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
              Personel Üretim Karnesi
            </h1>
          </div>

          {/* Filtreler */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <User className="inline w-4 h-4 mr-1" />
                Personel Seç
              </label>
              <select
                value={selectedPersonnel}
                onChange={(e) => setSelectedPersonnel(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Personel seçin</option>
                <option value="all">🏢 Genel Şirket Üretimi</option>
                {personnelList.map((person) => (
                  <option key={person.id} value={person.id}>
                    {person.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <Calendar className="inline w-4 h-4 mr-1" />
                Ay Seç
              </label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Ay seçin</option>
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Yıl Seç
              </label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-end space-x-2">
              <button
                onClick={fetchReportData}
                disabled={loading}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg font-medium transition-colors disabled:opacity-50"
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Yükleniyor...
                  </span>
                ) : (
                  <span className="flex items-center justify-center">
                    <TrendingUp className="w-4 h-4 mr-2" />
                    Rapor Al
                  </span>
                )}
              </button>
              
              <button
                onClick={generatePDF}
                disabled={!reportData}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-lg font-medium transition-colors disabled:opacity-50"
              >
                <Download className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Rapor Sonuçları */}
        {reportData && (
          <div className="space-y-6">
            {/* Özet Kartlar */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Toplam Poliçe</p>
                    <p className="text-2xl font-bold text-blue-600">{reportData.summary?.total_policies || 0}</p>
                  </div>
                  <FileText className="h-8 w-8 text-blue-500" />
                </div>
              </div>

              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Toplam Prim</p>
                    <p className="text-2xl font-bold text-green-600">
                      {formatCurrency(reportData.summary?.total_premium || 0)}
                    </p>
                  </div>
                  <TrendingUp className="h-8 w-8 text-green-500" />
                </div>
              </div>

              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Poliçe Başı Üretim</p>
                    <p className="text-2xl font-bold text-purple-600">
                      {formatCurrency(reportData.summary?.average_premium || 0)}
                    </p>
                  </div>
                  <BarChart3 className="h-8 w-8 text-purple-500" />
                </div>
              </div>

              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Trafik Oranı</p>
                    <p className="text-2xl font-bold text-orange-600">
                      %{reportData.summary?.traffic_ratio || 0}
                    </p>
                  </div>
                  <BarChart3 className="h-8 w-8 text-orange-500" />
                </div>
              </div>
            </div>

            {/* Ürün Bazlı Analiz */}
            <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Ürün Bazlı Üretim</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full table-auto">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ürün</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Adet</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Toplam Prim</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ortalama Prim</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Oran</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {reportData.detail_by_product?.map((product, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {product.product_name}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                          {product.count}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                          {formatCurrency(product.premium)}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                          {formatCurrency(product.average_premium)}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                          %{product.percentage}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Personel Dağılımı (Sadece genel raporda) */}
            {reportData.personnel_distribution && reportData.personnel_distribution.length > 0 && (
              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Personel Bazlı Üretim</h3>
                <div className="overflow-x-auto">
                  <table className="min-w-full table-auto">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Personel</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Adet</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Toplam Prim</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ortalama Prim</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Oran</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {reportData.personnel_distribution.map((personnel, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {personnel.personnel_name}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                            {personnel.count}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                            {formatCurrency(personnel.premium)}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                            {formatCurrency(personnel.average_premium)}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                            <div className="flex items-center">
                              <span className="mr-2">%{personnel.percentage}</span>
                              <div className="w-16 bg-gray-200 rounded-full h-2">
                                <div 
                                  className="bg-blue-500 h-2 rounded-full" 
                                  style={{ width: `${Math.min(personnel.percentage, 100)}%` }}
                                ></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Şirket Tipi Analizi */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Bizim Acente */}
              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <h3 className="text-xl font-bold text-blue-800 mb-4">Bizim Acente Şirketleri</h3>
                <div className="mb-4 p-4 bg-blue-50 rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium">Toplam Poliçe:</span>
                    <span className="font-bold text-blue-600">{reportData.by_company_type?.bizim_acente?.count || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-medium">Toplam Prim:</span>
                    <span className="font-bold text-blue-600">{formatCurrency(reportData.by_company_type?.bizim_acente?.premium || 0)}</span>
                  </div>
                </div>
                <div className="space-y-2">
                  {Object.entries(reportData.by_company_type?.bizim_acente?.by_product || {}).map(([product, data]) => (
                    <div 
                      key={product} 
                      className="flex justify-between items-center p-2 bg-gray-50 rounded hover:bg-gray-100 cursor-pointer transition-colors"
                      onClick={() => {
                        const productData = reportData.detail_by_product?.find(p => p.product_name === product);
                        if (productData) showProductCompanies(productData);
                      }}
                    >
                      <span className="text-sm font-medium">{product}</span>
                      <div className="text-right">
                        <div className="text-sm font-bold">{data.count} adet</div>
                        <div className="text-xs text-gray-600">{formatCurrency(data.premium)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Dış Acente */}
              <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
                <h3 className="text-xl font-bold text-green-800 mb-4">Dış Acente Şirketleri</h3>
                <div className="mb-4 p-4 bg-green-50 rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium">Toplam Poliçe:</span>
                    <span className="font-bold text-green-600">{reportData.by_company_type?.dis_acente?.count || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-medium">Toplam Prim:</span>
                    <span className="font-bold text-green-600">{formatCurrency(reportData.by_company_type?.dis_acente?.premium || 0)}</span>
                  </div>
                </div>
                <div className="space-y-2">
                  {Object.entries(reportData.by_company_type?.dis_acente?.by_product || {}).map(([product, data]) => (
                    <div 
                      key={product} 
                      className="flex justify-between items-center p-2 bg-gray-50 rounded hover:bg-gray-100 cursor-pointer transition-colors"
                      onClick={() => {
                        const productData = reportData.detail_by_product?.find(p => p.product_name === product);
                        if (productData) showProductCompanies(productData);
                      }}
                    >
                      <span className="text-sm font-medium">{product}</span>
                      <div className="text-right">
                        <div className="text-sm font-bold">{data.count} adet</div>
                        <div className="text-xs text-gray-600">{formatCurrency(data.premium)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Trafik vs Diğer Analizi */}
            <div className="bg-white/80 backdrop-blur-lg rounded-xl p-6 shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Trafik vs Diğer Ürünler</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="p-4 bg-orange-50 rounded-lg">
                  <h4 className="font-bold text-orange-800 mb-2">Trafik Sigortası</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>Adet:</span>
                      <span className="font-bold">{reportData.traffic_analysis?.traffic_count || 0}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Toplam Prim:</span>
                      <span className="font-bold">{formatCurrency(reportData.traffic_analysis?.traffic_premium || 0)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Oran:</span>
                      <span className="font-bold">%{reportData.summary?.traffic_ratio || 0}</span>
                    </div>
                  </div>
                </div>
                <div className="p-4 bg-blue-50 rounded-lg">
                  <h4 className="font-bold text-blue-800 mb-2">Diğer Ürünler</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>Adet:</span>
                      <span className="font-bold">{reportData.traffic_analysis?.other_count || 0}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Toplam Prim:</span>
                      <span className="font-bold">{formatCurrency(reportData.traffic_analysis?.other_premium || 0)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Oran:</span>
                      <span className="font-bold">%{100 - (reportData.summary?.traffic_ratio || 0)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Şirket Dağılımı Modal */}
        {showCompanyModal && selectedProductCompanies && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">
                  {selectedProductCompanies.product_name} - Şirket Dağılımı
                </h3>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              <div className="mb-4 p-4 bg-blue-50 rounded-lg">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm text-gray-600">Toplam Poliçe:</span>
                    <div className="text-xl font-bold text-blue-600">{selectedProductCompanies.count}</div>
                  </div>
                  <div>
                    <span className="text-sm text-gray-600">Toplam Prim:</span>
                    <div className="text-xl font-bold text-blue-600">{formatCurrency(selectedProductCompanies.premium)}</div>
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                {selectedProductCompanies.companies?.map((company, index) => (
                  <div key={index} className={`p-4 rounded-lg border-l-4 ${
                    company.type === 'bizim' ? 'border-blue-500 bg-blue-50' : 'border-green-500 bg-green-50'
                  }`}>
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="font-bold text-gray-800">{company.company_name}</h4>
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        company.type === 'bizim' ? 'bg-blue-200 text-blue-800' : 'bg-green-200 text-green-800'
                      }`}>
                        {company.type === 'bizim' ? 'Bizim Acente' : 'Dış Acente'}
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div>
                        <span className="text-gray-600">Adet:</span>
                        <div className="font-bold">{company.count}</div>
                      </div>
                      <div>
                        <span className="text-gray-600">Prim:</span>
                        <div className="font-bold">{formatCurrency(company.premium)}</div>
                      </div>
                      <div>
                        <span className="text-gray-600">Oran:</span>
                        <div className="font-bold">%{company.percentage}</div>
                      </div>
                    </div>

                    {/* Progress Bar */}
                    <div className="mt-3">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className={`h-2 rounded-full ${
                            company.type === 'bizim' ? 'bg-blue-500' : 'bg-green-500'
                          }`}
                          style={{ width: `${company.percentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  onClick={closeModal}
                  className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonelKarnesi;